export const NOTES_CONTENT_MAX_LENGTH = 2000;

export type MoveToNoteResult = { projectId: string } | null;

export function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, '').trim();
}

export function notePreview(content: string, maxLen: number): string {
  const text = stripHtml(content);
  if (text.length <= maxLen) return text;
  return text.slice(0, maxLen) + '...';
}
